const blogSection = document.querySelector(".blog-wrap");
const blogbody = document.getElementsByTagName("body")[0];




if (blogSection) {
  

  const searchClient = algoliasearch('LKYK6WM342', 'e6cda3824c0852f67eeed226fc7bb704');

  const search = instantsearch({
    indexName: 'blog',
    searchClient,
  });
 


  search.addWidgets([
    instantsearch.widgets.searchBox({
      container: '#blog_search',
      placeholder: 'Search'
    }),

    instantsearch.widgets.configure({
      hitsPerPage: 10,
    }),
 
  ]);

//----------hits --------
setTimeout(function () {
  search.addWidget(
    instantsearch.widgets.hits({
      container: '#blog_hits',
  
      templates: {
        item: function (hit) {
          let linkk = `/${hit.search_api_id.split(":")[1]}`
          var temp
          let paragraphs = refinePara(hit.processed);
          let authDate  = (hit.created == undefined ? '' : hit.created)
          temp = (new Date((authDate) * 1000)).toDateString()
          let monthname = dateFormatter(temp.split(" ")[1])
          let date = `${monthname} ${temp.split(" ")[2]}, ${temp.split(" ")[3]}`
           var editLink = handleEdit(linkk)
          return `
          <div class="card">
           <a href=${hit.url} class="empty-link">.</a>
           ${editLink !== undefined ? editLink :''}
            <span>${date}</span>
            <h4>
            ${hit.name == undefined ? (hit.title) : hit.name}
            </h4>
            ${hit.processed == undefined ? '' : (`<p>${paragraphs}</p>`)}
          </div>
        `;
        },
        empty:`<span>No result found for "{{query}}"`,
        
      },
      sortBy: ["created:desc"],
    })
  ).on('render', function () {
    const hitsContainer = blogSection.querySelector('#blog_hits');
    const child = hitsContainer.children[0]
    const listItemElements = hitsContainer.querySelectorAll('li');
    const div = document.createElement('div');
    listItemElements.forEach(function (li, index) {
      div.innerHTML += li.innerHTML;
    });
    if(child !== undefined){
    hitsContainer.replaceChild(div, child);
    }

    if (hitsContainer.children[1] != undefined) {
      if (listItemElements.length == 0) { 
        hitsContainer.removeChild(hitsContainer.children[0])
        var inputval = document.querySelector("#blog_search .ais-SearchBox-input").value
        console.log(inputval);
        (hitsContainer).innerHTML = `<span>No result found for "${inputval}"</span>`
      } else {
        hitsContainer.removeChild(hitsContainer.children[1])
      }
    }
  })
}, 1200)
  
//--refine paragraph-----


function refinePara(processed) {
  if(processed != undefined){
  let paragraphs = processed.split('\n\n');
  let containsImages = paragraphs.some((paragraph) => paragraph.includes('<img'));

  let bodyHTML = '';
  bodyHTML = processed.replace(/<[^>]*>?/gm, '')

  return bodyHTML
  }
}
  //------- add edit btn on login ----------

  function handleEdit(link) {
    if (blogbody.getAttribute("id") == "admin-logged-in") {
      return (`<a class="edit-link" href="${link}/edit/">[Edit]</a>`)
    }
  }
  

  //---------- finantial year ----------  
  search.addWidget(
    instantsearch.widgets.refinementList({
      container: '#year_blogs',
      attribute: 'finacial_year',
      limit: 1000,
      operator: "or",
      searchable: true,
      sortBy: ["name:desc"],
      cssClasses: {
        root: 'MyCustomRefinementList1',
        list: [
          'list-wrap',
        ],
      },
    })
  );


 
  //----- civic-fed-issues ----------

  search.addWidget(
    instantsearch.widgets.refinementList({
      container: '#civic_fed_issues',
      attribute: 'civic_fed_issues',
      limit: 100,
      operator: "or",
      searchable: true,
      sortBy: ["changed:desc"],
      cssClasses: {
        root: 'MyCustomRefinementList1',
        list: [
          'list-wrap',
        ],
      },
    
    })
  );

  //-------- government ------------

  search.addWidget(
    instantsearch.widgets.refinementList({
      container: '#government_blogs',
      attribute: 'govt_name',
      limit: 100,
      operator: "or",
      searchable: true,
      sortBy: ["changed:desc"],
      cssClasses: {
        root: 'MyCustomRefinementList1',
        list: [
          'list-wrap',
        ],
      },
    })
  );



  setTimeout(function () {
    search.on('render', function () {
      const yearFacetsCount = search.helper.getRefinements('finacial_year').length;
      const fedIssueFacetsCount = search.helper.getRefinements('civic_fed_issues').length;
      const govtFacetsCount = search.helper.getRefinements('govt_name').length;
      
      var inputElement
  
      inputElement = document.querySelectorAll('.ais-SearchBox-input');

      if (yearFacetsCount > 0) {
        inputElement[2].placeholder = `${yearFacetsCount} item selected`
      } else {
        inputElement[2].placeholder = `-Any-`
      }
      if (fedIssueFacetsCount > 0) {
        inputElement[1].placeholder = `${fedIssueFacetsCount} item selected`
      } else {
        inputElement[1].placeholder = `-Any-`
      }
      if (govtFacetsCount > 0) {
        inputElement[3].placeholder = `${govtFacetsCount} item selected`
      } else {
        inputElement[3].placeholder = `-Any-`
      }

  
    });
  }, 2000);




  //----- clear all 
  search.addWidget(
    instantsearch.widgets.clearRefinements({
      container: '#reset-btn',
      templates: {
        resetLabel: 'Reset',
      },
    }),
  );

  //--------- pagination ------------

  const customTemplates = {
    // Use {{label}} to represent the button label
    previous: ' ‹ Previous',
    next: 'Next › ',
  };
  
  search.addWidget(
    instantsearch.widgets.pagination({
      container: '#pagination',
      templates: customTemplates,
    })
  );

  


  search.start();

  // if (myParam != undefined) {
  //   var query = myParam
  //   search.helper.setQuery(query).search();
  // }

  //-----------date formatter ------------
  function dateFormatter(dateVal) {
    let month = dateVal;
    switch (month) {
      case 'Jan':
        return 'January';
      case 'Feb':
        return 'February';
      case 'Mar':
        return 'March';
      case 'Apr':
        return 'April';
      case 'May':
        return 'May';
      case 'Jun':
        return 'June';
      case 'Jul':
        return 'July';
      case 'Aug':
        return 'August';
      case 'Sep':
        return 'September';
      case 'Oct':
        return 'October';
      case 'Nov':
        return 'November';
      case 'Dec':
        return 'December';
      default:
        return 'foo';
    }
  }



  //----------------click----------------
  setTimeout(function () {
 
    var fields = blogSection.querySelectorAll(".field-wrap .custom-select")
    var itemlist = blogSection.querySelectorAll(".ais-RefinementList  .list-wrap")
  
    fields.forEach(function (item, index) {
      var input = item.querySelector(".ais-SearchBox-input")
      input.setAttribute('readOnly', 'true')
      input.placeholder = "-Any-"

      item.addEventListener("click", function () {
    
        if (item.classList.contains("active")) {
          item.classList.remove("active")
        } else {
          for (let i = 0; i < fields.length; i++) {
            fields[i].classList.remove("active")
          }
          item.classList.add("active")
        }

      })
    })
  
    document.addEventListener("click", function (e) {
   
      if (!(e.target).classList.contains("ais-SearchBox-input")) {
        for (let i = 0; i < fields.length; i++) {
    
          fields[i].classList.remove("active")
        }
     
      } else {
        // console.log("")
        return;
      }
      
    
    })
  
  
  
  }, 1700);

}